import { useEffect } from "react";
import nprogress from "nprogress";

nprogress.configure({
  showSpinner: false,
  parent: "#main",
});

export function NProgress(): null {
  useEffect((): (() => void) => {
    nprogress.start();
    return () => nprogress.done();
  });

  return null;
}
